import OidcClient from '@sdb-develop/learning-oidc-client/index.js';
import {
    SILENT_RENEW_ERROR,
    USER_EXPIRED,
} from '@sdb-develop/learning-redux-oidc-es6/src/constants/index.js';
import { userManager } from './userManager.js';

const { Log } = OidcClient;

// oidc-client defaults to a nop logger, which hides every renewal problem.
// WARN keeps the volume low while still surfacing failed silent renews.
export const configureOidcLogging = () => {
    Log.logger = console;
    Log.level = Log.WARN;
};

// createOidcMiddleware only subscribes to userLoaded (-> USER_FOUND). The events
// below have no subscriber at all, so an expired token or a failed silent renew
// never reaches redux and the app keeps sending a dead bearer token.
//
// Only the two token lifetime events are wired up. `userSignedOut` is left alone
// on purpose: the SessionMonitor raises it whenever its own querySessionStatus()
// call fails, and that call is a prompt=none request in a hidden iframe - exactly
// what a blocked third-party cookie on the STS looks like. The check session
// iframe polls every 2 seconds, so it fired within seconds of every login and
// bounced the user back through the STS, over and over. monitorSession is off for
// that reason (see userManager.js), and a session that really ended at the STS
// still surfaces here as an expired token at the latest.
export const registerOidcEvents = (store) => {
    userManager.events.addSilentRenewError((error) => {
        Log.error('silent renew failed', error);
        store.dispatch({ type: SILENT_RENEW_ERROR, payload: error });
    });

    userManager.events.addAccessTokenExpired(() => {
        Log.warn('access token expired');
        store.dispatch({ type: USER_EXPIRED });
    });
};
